import { X } from "lucide-react";

/** Banner shown on a page that is filtered to one person (see lib/user-filter.ts). */
export function UserFilterChip({ name, onClear }: { name?: string; onClear: () => void }) {
  return (
    <div className="flex items-center justify-between gap-2 rounded-lg border border-blue-300/50 bg-blue-500/10 px-3 py-2 text-sm">
      <span className="min-w-0 truncate">
        Showing records for <strong>{name ?? "this person"}</strong>
      </span>
      <button
        type="button"
        onClick={onClear}
        className="inline-flex items-center gap-1 shrink-0 text-xs font-medium text-blue-700 dark:text-blue-300 hover:underline"
      >
        <X className="h-3.5 w-3.5" />
        Show everyone
      </button>
    </div>
  );
}
